angular.module('eatself')
.filter('optionCount', function() {
  return function(input) {
  	if (!input) return '00';
  	if (input < 10) return '0' + input;
  	return input;
  };
})